import { Storage } from "@codeArt/common";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

//检测目标
const initialState = {
  value:null
};

export const goalSlice = createSlice({
  name: "goal",
  initialState,
  reducers: {
    setGoal: (state, action) => {
      state.value = action.payload;
      Storage.set("defect_goal", state.value);
    }
  }
});

export const {setGoal} = goalSlice.actions;

export default goalSlice.reducer;
